import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { ProcedureTypeSettingsViewTopBar } from "./TopBar"

export const procedureTypeSettingsViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: ProcedureTypeSettingsViewTopBar,
}
